import { createAction } from 'redux-actions';
import {
    SET_WAITING_HALL_UPDATE,
} from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actionTypes';

export default createAction(SET_WAITING_HALL_UPDATE);
